<template>
<div class="chapter">
<div class="inner_page">
<p><a id="fm1"></a></p>
<div class="fmhT">
    Praise for BALANCE YOUR HORMONES, BALANCE YOUR LIFE
  </div>
<div class="epiv">
    “Dr. Claudia Welch amalgamates Eastern medicine and Western science into a tidy and practical framework from whose clear perspective we can easily make sense of the complicated particulars of hormones and women’s health.”
  </div>
<div class="eps">
    —Dr. Robert Svoboda, BAMS, author of<br/>
<i>Ayurveda for Women: A Guide to Vitality and Health</i>
</div>
<div class="epiv">
<div>
       <br/>
</div>
<div>
       <br/>
</div>
<div>
       <br/>
</div>“A loving, compassionate healer and wonderful teacher, Dr. Claudia Welch has studied Ayurveda and Acupuncture extensively. She provides a new avenue and dimension of perception, integrating these two healing traditions to bring about holistic health.”
  </div>
<div class="eps">
    —Vasant Lad, BAMS, MASc, Ayurvedic Physician,<br/>
    author of <i>The Complete Book of Ayurvedic Home Remedies</i>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// clau_9780738214993_oeb_fm1_r1.vue?25be0f16